import React from 'react'
import classes from "./Fifth.module.scss"
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper/modules';
import { Pagination, Navigation } from "swiper/core";
import 'swiper/css';
import img1 from "../../../assets/img/costcall/5/1.png"
import img2 from "../../../assets/img/costcall/5/2.png"
import img3 from "../../../assets/img/costcall/5/3.png"
import img4 from "../../../assets/img/costcall/5/4.png"
import img5 from "../../../assets/img/costcall/5/5.png"

const Fifth = () => {

    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + '</span>';
        },
    };

    return (
        <div className={[classes.fifth, "pt pb"].join(" ")}>
            <div className={[classes.fifthBody, ""].join(" ")}>
                <div className="container">
                    <div className={[classes.fifthTop, ""].join(" ")}>
                        <div className={[classes.fifthTopLeft, ""].join(" ")}>
                            <div className={[classes.fifthTopLeftTitle, "font-40"].join(" ")}>
                                Что вы получите,
                                <span> выбрав Bomber VPN</span>
                            </div>
                            <div className={[classes.fifthTopLeftDecor, "decor"].join(" ")}>
                                <span></span><span></span><span></span>
                            </div>
                        </div>
                        <div className={[classes.fifthTopRight, ""].join(" ")}>
                            <a href='#' className={[classes.firstContentLeftBottomItem, ""].join(" ")}>
                                <img src={img1} alt="" />
                                <div className={[classes.firstContentLeftBottomItemWrap, ""].join(" ")}>
                                    <span>Скачать в </span>
                                    <span>Google play</span>
                                </div>
                            </a>
                            <a href='#' className={[classes.firstContentLeftBottomItem, ""].join(" ")}>
                                <img src={img2} alt="" />
                                <div className={[classes.firstContentLeftBottomItemWrap, ""].join(" ")}>
                                    <span>Скачать в </span>
                                    <span>APPLE STORE</span>
                                </div>
                            </a>
                        </div>



                    </div>

                    <div className={[classes.fifthSlider, ""].join(" ")}>
                        <Swiper
                            pagination={pagination}
                            modules={[Pagination, Navigation]}
                            navigation={true}
                            // pagination={{
                            //     clickable: true,
                            // }}

                            breakpoints={{
                                320: {
                                    slidesPerView: 1,
                                    spaceBetween: 10
                                },
                                768: {
                                    slidesPerView: 2,
                                    spaceBetween: 20,

                                },
                                1420: {
                                    slidesPerView: 3,
                                    spaceBetween: 42
                                },
                            }}
                            onSlideChange={() => console.log('slide change')}
                            onSwiper={(swiper) => console.log(swiper)}
                        >
                            <SwiperSlide>
                                <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                    <div className={[classes.fifthSliderSlideTop, ""].join(" ")}>
                                        <div className={[classes.fifthSliderSlideTopImg, ""].join(" ")}>
                                            <img src={img3} alt="" />
                                        </div>
                                        <p className={[classes.fifthSliderSlideTopTitle, ""].join(" ")}>
                                            Шифрование данных
                                        </p>
                                    </div>
                                    <p className={[classes.fifthSliderSlideText, "font-22"].join(" ")}>
                                        Bomber VPN использует мощные шифровальные методы для защиты передаваемой информации от доступа третьих лиц. Это позволяет пользователям отправлять и получать данные через общедоступные или потенциально небезопасные сети (например, общественные Wi-Fi точки) без опасения за их конфиденциальность.
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                    <div className={[classes.fifthSliderSlideTop, ""].join(" ")}>
                                        <div className={[classes.fifthSliderSlideTopImg, ""].join(" ")}>
                                            <img src={img4} alt="" />
                                        </div>
                                        <p className={[classes.fifthSliderSlideTopTitle, ""].join(" ")}>
                                            Полная
                                            анонимность
                                        </p>
                                    </div>
                                    <p className={[classes.fifthSliderSlideText, "font-22"].join(" ")}>
                                        Bomber VPN скрывает реальный IP-адрес пользователя и заменяет его IP-адресом сервера VPN. Это делает сложным отслеживание пользовательской активности в Интернете, обеспечивая большую анонимность. Кроме того, VPN-сервисы обычно не хранят логи активности пользователей, что дополнительно укрепляет приватность
                                    </p>
                                </div>
                            </SwiperSlide>
                            <SwiperSlide>
                                <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                    <div className={[classes.fifthSliderSlideTop, ""].join(" ")}>
                                        <div className={[classes.fifthSliderSlideTopImg, ""].join(" ")}>
                                            <img src={img5} alt="" />
                                        </div>
                                        <p className={[classes.fifthSliderSlideTopTitle, ""].join(" ")}>
                                            Обход
                                            блокировок
                                        </p>
                                    </div>
                                    <p className={[classes.fifthSliderSlideText, "font-22"].join(" ")}>
                                        Bomber VPN позволяет обходить ограничения, устанавливаемые государственными или корпоративными структурами на доступ к определенным сайтам, сервисам или контенту. Подключение к серверам в других странах позволяет получить доступ к контенту, который может быть недоступен из-за географических ограничений
                                    </p>
                                </div>
                            </SwiperSlide>
                            {/* <SwiperSlide>
                                <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                    <div className={[classes.fifthSliderSlideTop, ""].join(" ")}>
                                        <div className={[classes.fifthSliderSlideTopImg, ""].join(" ")}>
                                            <img src={img3} alt="" />
                                        </div>
                                        <p className={[classes.fifthSliderSlideTopTitle, ""].join(" ")}>
                                            Шифрование данных
                                        </p>
                                    </div>
                                    <p className={[classes.fifthSliderSlideText, "font-22"].join(" ")}>
                                        Bomber VPN использует мощные шифровальные методы для защиты передаваемой информации от доступа третьих лиц. Это позволяет пользователям отправлять и получать данные через общедоступные или потенциально небезопасные сети (например, общественные Wi-Fi точки) без опасения за их конфиденциальность.
                                    </p>
                                </div>
                            </SwiperSlide> */}
                        </Swiper>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default Fifth